let inject = ['$scope', '$uibModalInstance','modalOptions'];

class ModalLoginResponseController {
  constructor ($scope,$uibModalInstance,modalOptions) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = Object.assign({}, modalOptions);
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

ModalLoginResponseController.$inject = inject;

export default ModalLoginResponseController;



/** WEBPACK FOOTER **
 ** ./www/components/login/modal-login-response/modal-login-response.controller.js
 **/